<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <h2 class="bg-green-500 py-3 px-5 text-white mb-8">
      Step 2: Your Information
    </h2>
    <form @submit.prevent="passes(goToNextPage)">
      <div class="flex flex-wrap -mx-5">
        <d-field label="Your First Name" class="px-5 w-full md:w-1/2">
          <d-input v-model="submittorFirstName" aria-label="Your first name" required />
        </d-field>
        <d-field label="Your Last Name" class="px-5 w-full md:w-1/2">
          <d-input v-model="submittorLastName" aria-label="Your last name" required />
        </d-field>
      </div>
      <d-field label="Submitter Email" rules="required|email">
        <d-input v-model="submittorEmail" aria-label="Your email" required type="email" />
      </d-field>
      <d-field label="Your Phone">
        <d-input v-model="submittorPhone" aria-label="your phone number" required />
      </d-field>

      <d-field label="I am reporting the following update in this project's status" class="mb-5" rules="required">
        <div>
          <div class="mb-1">
            <d-radio v-model="updateProjectStatus" native-value="Awarded to GC">
              Awarded to General Contractor
            </d-radio>
          </div>
          <div class="mb-1">
            <d-radio v-model="updateProjectStatus" native-value="Awarded to WW">
              Awarded to Woodwork Subcontractor
            </d-radio>
          </div>
          <div class="mb-1">
            <d-radio v-model="updateProjectStatus" native-value="Awarded to Other">
              Other
            </d-radio>
          </div>
        </div>
      </d-field>

      <div v-if="updateProjectStatus == 'Awarded to Other'">
        <d-field label="If &quot;Other&quot;, please specify">
          <d-input v-model="other" aria-label="other" placeholder="Enter any comments or notes" type="textarea" required />
        </d-field>
      </div>

      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn class="mx-5" @click="goToPrevPage">
          Prev <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
        <d-btn type="submit" class="mx-5 md:mx-0">
          Next <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '@resources/scripts/utilities/field.utilities';
  import { PROJECT_UPDATE_FORM } from '@resources/scripts/store/mutation-types';

  const { mapActions } = createNamespacedHelpers('projectUpdateForm');

  export default {
    computed: {
      ...mapFields({
        fields: ['submittorFirstName', 'submittorLastName', 'submittorEmail', 'submittorPhone', 'updateProjectStatus', 'other'],
        module: 'projectUpdateForm',
        base: 'formFields',
        mutation: PROJECT_UPDATE_FORM.FORM_FIELDS,
      }),
    },

    methods: {
      ...mapActions([
        'goToPrevPage',
        'goToNextPage',
      ]),
    },
  };
</script>